import { Col, Form, Row } from "antd";
import FormItem from "antd/lib/form/FormItem";
import React, { forwardRef, useImperativeHandle } from "react";
import { DisplayFlex, InputField } from "../commonStyles";
import { Align, EmailTitleWrapper, EmailWrapper, ErrFormItem, InputWrapper, LabelWrapper, RowWrapper, TitleMarginTop, WrapLabel } from "../../Epics/MyAccounts/Components/Step1Setup/styles";


const  getInitValue = (email = [],type)=>{
    return email.reduce((acc,eml)=>{if(eml.emailtype === type){
        acc = eml.emailId
    }
return acc;
},null)
 }
const EmailForm  = forwardRef(({ email = [], disabled=false, form, elementIds}, ref)=> {

    useImperativeHandle(ref, () => ({
        form
    }));

    const { getFieldDecorator } = form;

    let elmID = {
        primary: 'primary',        
        other: "other"        
    }

    if(elementIds) {
        elmID = elementIds;
    }

    return (
      <RowWrapper>
        <LabelWrapper>Email</LabelWrapper>
        <div data-test="secondary-advisor-form-block">
                <div>
                    <Row gutter={24}>
                        <Col lg={{ span: 7 }} md={{ span: 9 }}>
                            <WrapLabel>
                                <FormItem
                                    colon={false}
                                    label={
                                        <EmailWrapper>
                                            <DisplayFlex>
                                                <Align>
                                                    <TitleMarginTop>
                                                        <EmailTitleWrapper>Primary Email Address</EmailTitleWrapper>
                                                    </TitleMarginTop>
                                                </Align>
                                            </DisplayFlex>
                                        </EmailWrapper>
                                    }
                                >
                                      <InputWrapper>
                                    {getFieldDecorator(elmID.primary, {
                                        rules: [
                                            {
                                                required: true,
                                                message: <ErrFormItem>Please enter  email address.</ErrFormItem>
                                            },
                                            {pattern:/^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/,
                                        message:<ErrFormItem>Please enter valid  email address.</ErrFormItem>}
                                        ],
                                        validateTrigger: ["onChange", "onBlur"],
                                        initialValue:getInitValue(email,"Primary")
                                    })(
                                      
                                            <InputField
                                                data-test="email-address-inputblock"
                                                aria-label="email-address"
                                                placeholder="Enter email address"
                                                disabled={disabled}
                                                className="remove_error_style"
                                            />
                                        
                                    )}
                                    </InputWrapper>
                                </FormItem>
                            </WrapLabel>
                        </Col>

                        <Col lg={{ span: 7 }} md={{ span: 9 }}>
                            <WrapLabel>
                                <FormItem
                                    colon={false}
                                    label={
                                        <EmailWrapper>
                                            <DisplayFlex>
                                                <Align>
                                                    <TitleMarginTop>
                                                        <EmailTitleWrapper>Other Email Address (optional)</EmailTitleWrapper>
                                                    </TitleMarginTop>
                                                </Align>
                                            </DisplayFlex>
                                        </EmailWrapper>
                                    }
                                >
                                    <InputWrapper>
                                    {getFieldDecorator(elmID.other, {
                                        rules: [
                                          {pattern:/^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/,
                                          message:<ErrFormItem>Please enter valid  email address.</ErrFormItem>}
                                        ],
                                        initialValue:getInitValue(email,"Other")
                                    })(
                                        
                                            <InputField
                                                data-test="secondary-adv-email-block"
                                                aria-label="email-address"
                                                placeholder="Enter email address"
                                                className="remove_error_style"
                                                disabled={disabled}
                                            />
                                        
                                    )}
                                    </InputWrapper>
                                </FormItem>

                            </WrapLabel>
                        </Col>

                    </Row>
                </div>



            </div>
        
      </RowWrapper>
    );
  
})

const WrappedEmailForm = Form.create({ name: "email",onValuesChange(props, changedValues, value){
    const { elementIds } = props;
    const primary = elementIds ? value[elementIds.primary]: value['primary'];    
    const other = elementIds ? value[elementIds.other]: value['other'];
    props.handleChange({
          email: [{
            emailtype:"Primary",
              emailId:primary
          },...(!!other?[{emailtype:"Other",emailId:other}]:[{ emailtype:"Other",
          emailId:""}])]
      });
} })(EmailForm);


export default WrappedEmailForm;
